module.exports = __webpack_public_path__ + "static/hudl.d56ba1f1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/documents/pdfs/hudl.pdf
// module id = 1532
// module chunks = 157636680307020